/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Google_ContinueInputs */

const cs_auth_google_continue = /** @type {(inputs: Auth_Google_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokračovat přes Google`)
};

const en_auth_google_continue = /** @type {(inputs: Auth_Google_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Auth_Google_ContinueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_google_continue = /** @type {((inputs?: Auth_Google_ContinueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Google_ContinueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_google_continue(inputs)
	return cs_auth_google_continue(inputs)
});